import createEnum from 'scripts/lib/create_enum';

const FeatureNotificationTypes = createEnum('REPORTS_AND_INSIGHTS_CLASSROOM');
export default FeatureNotificationTypes;
